<template>
  <div class="absolute top-0 left-0 h-full w-full z-0 opacity-10">
    <div class="relative h-full w-full graphics-container-service -translate-y-[40%] md:-translate-y-[20%]">

      <div id="scene-2" class="absolute top-0 left-0 h-full w-full">
        <div class="layer" data-depth="0.2">
          <div class="absolute top-1/2 left-1/2 -translate-x-[150%] md:-translate-x-[200%] -translate-y-[400%]">
            <img class="floating-element floating-element-1" src="/graphics/obj/graph-1.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.2">
          <div class="absolute top-1/2 left-1/2 translate-x-[80%] md:translate-x-[100%] -translate-y-[250%]">
            <img class="floating-element floating-element-2" src="/graphics/obj/graph-2.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.3">
          <div class="absolute top-1/2 left-1/2 -translate-x-[10%] md:-translate-x-[100%] -translate-y-[300%]">
            <img class="floating-element floating-element-3" src="/graphics/obj/graph-3.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.3">
          <div class="absolute top-1/2 left-1/2 -translate-x-[10%] md:-translate-x-[400%] translate-y-[50%] rotate-45 scale-[2]">
            <img class="floating-element floating-element-3" src="/graphics/obj/graph-3.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.3">
          <div class="absolute top-1/2 left-1/2 -translate-x-[180%] md:-translate-x-[100%] translate-y-[260%] hidden md:block">
            <img class="floating-element floating-element-4" src="/graphics/obj/graph-4.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.4">
          <div class="absolute top-1/2 left-1/2 -translate-x-[180%] md:-translate-x-[500%] translate-y-[200%]">
            <img class="floating-element floating-element-5" src="/graphics/obj/graph-5.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.4">
          <div class="absolute top-1/2 left-1/2 translate-x-[100%] md:translate-x-[300%] translate-y-[220%]">
            <img class="floating-element floating-element-6" src="/graphics/obj/graph-6.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.4">
          <div class="absolute top-1/2 left-1/2 -translate-x-[190%] md:-translate-x-[450%] -translate-y-[150%]">
            <img class="floating-element floating-element-7" src="/graphics/obj/graph-7.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.4">
          <div class="absolute top-1/2 left-1/2 -translate-x-[120%] md:-translate-x-[300%] translate-y-[300%] hidden md:block">
            <img class="floating-element floating-element-8" src="/graphics/obj/graph-8.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.6">
          <div class="absolute top-1/2 left-1/2 translate-x-[70%] md:translate-x-[400%] -translate-y-[500%] hidden md:block">
            <img class="floating-element floating-element-9" src="/graphics/obj/graph-9.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.6">
          <div class="absolute top-1/2 left-1/2 translate-x-[100%] md:translate-x-[450%] -translate-y-[0%] hidden md:block">
            <img class="floating-element floating-element-10" src="/graphics/obj/graph-10.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.6">
          <div class="absolute top-1/2 left-1/2 translate-x-[50%] md:translate-x-[150%] translate-y-[300%]">
            <img class="floating-element floating-element-11" src="/graphics/obj/graph-11.svg" alt="graphic-content" />
          </div>
        </div>

        <div class="layer" data-depth="0.4">
          <div class="absolute top-1/2 left-1/2 -translate-x-[100%] md:translate-x-[100%] -translate-y-[20%] -rotate-[24deg] hidden md:block">
            <img class="floating-element floating-element-12" src="/graphics/obj/graph-13.svg" alt="graphic-content" />
          </div>
        </div>

        <!-- <div class="layer" data-depth="0.1">
          <div class="absolute top-1/2 left-1/2 -translate-x-[100%] md:-translate-x-[100%] -translate-y-[100%]">
            <img class="floating-element floating-element-1" src="/graphics/obj/graph-12.svg" alt="graphic-content" />
          </div>
        </div> -->

        <div class="layer" data-depth="1">
          <div class="absolute top-1/2 left-1/2 -translate-x-[100%] md:-translate-x-[100%] -translate-y-[320%] hidden md:block">
            <img class="floating-element floating-element-12" src="/graphics/obj/graph-13.svg" alt="graphic-content" />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
const { $anime, $Parallax } = useNuxtApp();
const { $gsap, $ScrollTrigger } = useNuxtApp();

const isM = useMediaQuery('(min-width: 768px)');
const isL = useMediaQuery('(min-width: 1024px)');

const initParallax = () => {
  const scene = document.querySelector('#scene-2');
  const parallaxInstance = new $Parallax(scene);
};

onMounted(() => {
  // nextTick(() => {
  //   if (isL.value) {
  //     initParallax();
  //   }
  // });
});
</script>
